import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Home from './pages/Home';
import UserPage from './pages/UserPage';
import Matematik from './pages/Matematik';
import Dansk from './pages/Dansk';
import Geografi from './pages/Geografi';

export default function App() {
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/nico" element={<UserPage user="nico" name="Nico" age={7} color="#f9c74f" emoji="⚡" />} />
      <Route path="/carl" element={<UserPage user="carl" name="Carl" age={11} color="#4cc9f0" emoji="🚀" />} />
      <Route path="/nico/matematik" element={<Matematik user="nico" name="Nico" age={7} />} />
      <Route path="/carl/matematik" element={<Matematik user="carl" name="Carl" age={11} />} />
      <Route path="/nico/dansk" element={<Dansk user="nico" name="Nico" age={7} />} />
      <Route path="/carl/dansk" element={<Dansk user="carl" name="Carl" age={11} />} />
      <Route path="/nico/geografi" element={<Geografi user="nico" name="Nico" age={7} />} />
      <Route path="/carl/geografi" element={<Geografi user="carl" name="Carl" age={11} />} />
    </Routes>
  );
}
